import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { version } from '../../../../package.json';

@Component({
  selector: 'app-qr-main-layout',
  templateUrl: './qr-main-layout.component.html',
  styleUrls: ['./qr-main-layout.component.scss']
})
export class QrMainLayoutComponent implements OnInit {
  public appVersion = version;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
  }

  qrAppLogout() {
    this.auth.firebaseLogout().then(() => this.router.navigate(['/home']));
  }
}
